import { GenIcon } from '../helpers/IconBase.es.js';

const PhoneOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.9774 13.9669L13.0505 15.8677C12.0457 15.2618 11.1122 14.5448 10.2677 13.7302C9.45438 12.8843 8.73749 11.9507 8.13027 10.9465L10.0292 9.01967C10.2645 8.78079 10.332 8.42345 10.2002 8.11518L8.22027 3.50005C8.0586 3.12393 7.64588 2.92293 7.25008 3.02756L3.61954 3.98784C3.24616 4.08464 2.98926 4.42667 3.00035 4.81223C3.23135 9.03476 4.98702 13.03 7.94127 16.0558C10.9676 19.0109 14.9639 20.767 19.1875 20.9976C19.5736 21.0106 19.9168 20.7535 20.0128 20.3793L20.9722 16.747C21.0773 16.3514 20.8766 15.9385 20.5006 15.7768L15.8846 13.7977C15.5759 13.664 15.217 13.7309 14.9774 13.9669Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { PhoneOutlined };
